import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import * as jwt_decode from 'jwt-decode';
import { Router } from '@angular/router';
import { TransferDataService } from '../transfer-data/transfer-data.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private httpClient: HttpClient, private router: Router, private transferService: TransferDataService) { }
  login(user: object) {
    return this.httpClient.post(environment.API_URL + '/auth/signin', user, { responseType: 'json' });
  }

  loggedIn() {
    const token = localStorage.getItem(`token`);
    if (!!token) {
      try {
        const user = jwt_decode(token);
        return true;
      } catch (error) {
        return false;
      }
    } else {
      return false;
    }
  }
  getToken() {
    return localStorage.getItem('token');
  }
  logoutUser() {
    // this.transferService.setAuthUser(null);
    localStorage.removeItem(`token`);
    this.router.navigate(['/login']);
  }
  logout() {
    return this.httpClient.get(environment.API_URL + '/auth/logout', { responseType: 'json' });
  }
}
